module.exports = __webpack_public_path__ + "img/logo_icon@2x - 副本.cb37ad1c.png";